import React, { Component } from 'react'
import { connect } from 'react-redux'
import { actualizarDatosParaMuiTable } from '../actions/TablaPedidoCamionesEnPlayaInsatisfechoActions'
import { TablaPedidoCamionesEnPlayaInsatisfechoView } from '../components/TablaPedidoCamionesEnPlayaInsatisfechoView'

class TablaPedidoCamionesEnPlayaInsatisfecho extends Component {
  componentDidMount () {
    this.props.actualizarDatosParaMuiTable()
  }

  render () {
    return <TablaPedidoCamionesEnPlayaInsatisfechoView />
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}
const withRedux = connect(null, mapActionsToProps)
export default withRedux(TablaPedidoCamionesEnPlayaInsatisfecho)
